@let filter = filterSg();
@let statement = filter.statement;
@let comparison = filter.comparison;
@let id = idSg();

@if (id && (statement || comparison)) {
  <div
    class="atn-rate-gl-filter"
    [class.atn-rate-gl-filter--root]="depthSg() === 0"
  >
    @if (statement) {
      <atn-rate-gl-filter-statement
        [statement]="statement"
        [id]="id"
        (statementChange)="filterChange.emit($event)"
      />
    } @else if (comparison) {
      <div>
        <atn-rate-gl-filter-comparison
          [comparison]="comparison"
          [id]="id"
          (comparisonChange)="filterChange.emit($event)"
        />
        <!-- If we have only 1 comparison in the whole filter, we want to display
        the add group button here. That way we don't have to create the statement
        first in order to add group to our filter.  -->
        @if (depthSg() === 0) {
          <div
            class="atn-rate-gl-filter__group-add-btn"
            (click)="addGroup()"
          >
            <i class="atn-icon atn-plus atn-blue"></i>
            <p class="atn-rate-gl-filter__group-add-text">Add Group</p>
          </div>
        }
      </div>
    }
  </div>
} @else {
  <div class="atn-rate-gl-filter__empty-state-container">
    <div class="atn-rate-gl-filter__empty-state-content">
      <atn-ds-empty-state
        title="Ready to filter?"
        description="Click the button below to
        start creating a general ledger filter."
        action="Get Started"
        layout="v"
        type="add-row"
        (action)="createFilter()"
      />
    </div>
  </div>
}
